import React, { memo } from "react";
import AnimatedChat from "./AnimatedChat";
import AnalyticsDashboard from "./AnalyticsDashboard";
import WorkflowAnimation from "./WorkflowAnimation";
import CreatorDashboard from "./CreatorDashboard";

const DEMOS = {
  chat: AnimatedChat,
  analytics: AnalyticsDashboard,
  workflow: WorkflowAnimation,
  creator: CreatorDashboard,
};

// Renders the correct running demo for a slide. `active` pauses/plays the
// internal loops so off-screen demos don't burn frames.
const RunningDemo = ({ type, active }) => {
  const Demo = DEMOS[type];
  if (!Demo) return null;
  return (
    <div className="relative mx-auto flex w-full max-w-md items-center justify-center sm:max-w-lg md:max-w-none">
      {/* Glow behind the device */}
      <div className="pointer-events-none absolute inset-0 flex items-center justify-center overflow-hidden">
        <div className="h-40 w-40 rounded-full bg-orange-500/20 blur-3xl sm:h-56 sm:w-56" />
        <div className="absolute h-36 w-36 translate-x-8 rounded-full bg-blue-500/15 blur-3xl sm:h-48 sm:w-48 sm:translate-x-12" />
      </div>
      <div className="relative z-10 h-[300px] w-full min-w-0 sm:h-[360px] md:h-[400px]">
        <Demo active={active} />
      </div>
    </div>
  );
};

export default memo(RunningDemo);
